import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { KeyValue } from "abweb/utils/KeyboardUtils";
import { LogUtils } from "abweb/utils/log/LogUtils";
export class MouseMoveTracker {
  constructor(htmlElement) {
    // @ts-ignore: noUnusedLocals
    _defineProperty(this, "rootElem", void 0);
    // the <html> element on the page
    _defineProperty(this, "onMouseMoveBound", void 0);
    _defineProperty(this, "onMouseUpBound", void 0);
    _defineProperty(this, "cbCancel", void 0);
    _defineProperty(this, "cursorShapeOverlay", null);
    _defineProperty(this, "doc", void 0);
    _defineProperty(this, "logger", LogUtils.getLogger(__filename));
    if (htmlElement == null) {
      this.doc = document;
      this.logger.warn("Using the MouseMoveTracker without an htmlElement will break in an iFrame");
    } else {
      this.doc = htmlElement.ownerDocument;
    }
    this.rootElem = this.doc.documentElement; // the <html> element on the page
    this.onMouseMoveBound = this.onMouseMove.bind(this);
    this.onMouseUpBound = this.onMouseUp.bind(this);
    this.cursorShapeOverlayKeyDownHandler = this.cursorShapeOverlayKeyDownHandler.bind(this);
  }
  onMouseMove(e) {
    this.cbMoved(e.clientX - this.startClientX, e.clientY - this.startClientY, this.startClientX, this.startClientY);
  }
  onMouseUp(e) {
    this.release();
    this.cbReleased(e.clientX - this.startClientX, e.clientY - this.startClientY, this.startClientX, this.startClientY);
  }
  cursorShapeOverlayKeyDownHandler(event) {
    if (event.key === KeyValue.ESCAPE) {
      this.onCancel();
    }
  }
  onCancel() {
    this.release();
    if (this.cbCancel) {
      this.cbCancel();
    }
  }

  /**
   * Call this on a mouseDown event to track the mouse in order to drag a visual element.
   * Deltas are reported in pixels, relative to initial mouse click position.
   * deltaX is positive to the right, deltaY is positive when moving down.
   * @param mouseDownEvent the mouse down event that triggered tracking
   * @param cbMoved called every time mouse moves with distance moved from original click in pixels
   * @param cbReleased called when mouse is released
   * @param cursor CSS cursor name, the cursor to be shown while dragging
   * @param cbCancel called when tracking event is cancelled
   */
  track(mouseDownEvent, cbMoved, cbReleased, cursor, cbCancel) {
    this.release(); // in case stale handlers are around
    this.startClientX = mouseDownEvent.clientX;
    this.startClientY = mouseDownEvent.clientY;
    this.cbMoved = cbMoved;
    this.cbReleased = cbReleased;
    this.cbCancel = cbCancel;
    this.doc.defaultView?.addEventListener("mousemove", this.onMouseMoveBound, true);
    this.doc.defaultView?.addEventListener("mouseup", this.onMouseUpBound, true);
    if (cursor) {
      /* To change cursor shape everywhere while tracking is in effect
          we need to add an overlay div covering everything.
       */
      this.cursorShapeOverlay = this.doc.createElement("div");
      this.cursorShapeOverlay.tabIndex = 1;
      // TODO: This is very fragile, the z-index is at 5000 which works only in the react-layer-manager group and lower.
      this.cursorShapeOverlay.className = "mouse-move-tracker-overlay";

      /* Could have used class + CSS, but that means making sure the CSS
          gets picked up. Don't have a good method for that yet.
          So the style is baked in here.
       */
      let ccoStyle = this.cursorShapeOverlay.style;
      ccoStyle.cursor = cursor;
      this.doc.body.appendChild(this.cursorShapeOverlay);
      if (cbCancel) {
        this.cursorShapeOverlay.focus();
        this.cursorShapeOverlay.addEventListener("keydown", this.cursorShapeOverlayKeyDownHandler, true);
      }
    }
  }
  release() {
    this.doc.defaultView?.removeEventListener("mousemove", this.onMouseMoveBound, true);
    this.doc.defaultView?.removeEventListener("mouseup", this.onMouseUpBound, true);
    if (this.cursorShapeOverlay) {
      if (this.cbCancel) {
        this.cursorShapeOverlay.removeEventListener("keydown", this.cursorShapeOverlayKeyDownHandler, true);
      }

      // PJM: This does not seem to work to restore the cursor. In fact, I don't even think passing a cursor to track() even works.
      // It seems to "inherit" the cursor of the element from the mousedown event that started this off.
      // The cursor DOES get restored after the next mousemove, however, so this is a minor nit.
      this.cursorShapeOverlay.style.cursor = "auto";
      this.cursorShapeOverlay.parentElement?.removeChild(this.cursorShapeOverlay);
      this.cursorShapeOverlay = null;
    }
  }
}
//# sourceMappingURL=MouseMoveTracker.js.map
